<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'next/button/Button.vue';
import MultiSelect from './MultiSelect.vue';

const { options } = defineProps({
  options: { type: Array, required: true },
});

const { t } = useI18n();
const selected = defineModel({ type: Array, required: true });
const customValue = ref('');

// Valores digitados que não estão na lista também precisam virar opção para
// aparecerem como selecionados; valem só enquanto estiverem no filtro.
const allOptions = computed(() => {
  const knownIds = options.map(option => option.id);
  const custom = selected.value.filter(item => !knownIds.includes(item.id));
  return [...options, ...custom];
});

const addCustomValue = () => {
  const value = customValue.value.trim().toLowerCase();
  if (!value) return;
  if (!selected.value.some(item => item.id === value)) {
    selected.value = [...selected.value, { id: value, name: value }];
  }
  customValue.value = '';
};
</script>

<template>
  <div class="flex items-center gap-2">
    <MultiSelect
      v-if="allOptions.length"
      v-model="selected"
      :options="allOptions"
    />
    <input
      v-model="customValue"
      type="text"
      :placeholder="t('FILTER.CUSTOM_VALUE_PLACEHOLDER')"
      class="!h-8 !w-44 !py-0 !mb-0 !text-sm rounded-md outline outline-1 outline-n-weak bg-n-alpha-black2 text-n-slate-12"
      @keydown.enter.prevent="addCustomValue"
    />
    <Button
      type="button"
      sm
      slate
      faded
      icon="i-lucide-plus"
      :aria-label="t('FILTER.ADD_CUSTOM_VALUE')"
      @click="addCustomValue"
    />
  </div>
</template>
